import React from "react";
import Dropdown from "../DropDown";

interface MetricGroupISODropdownProps {
  selectedISO: string;
  onISOChange: (selectedISO: string) => void;
  disabled: boolean;
  className?: string;
  onFocus?: () => void;
}

const MetricGroupISODropdown: React.FC<MetricGroupISODropdownProps> = ({
  selectedISO,
  onISOChange,
  disabled,
  className = "",
  onFocus,
}) => {
  const options = [
    { value: "ALL", label: "ALL" },
    { value: "CAISO", label: "CAISO" },
    { value: "ERCOT", label: "ERCOT" },
    { value: "ISONE", label: "ISONE" },
    { value: "NYISO", label: "NYISO" },
    { value: "PJM", label: "PJM" },
  ];

  return (
    <Dropdown
      options={options}
      selectedValue={selectedISO}
      onValueChange={onISOChange}
      disabled={disabled}
      className={className}
      placeholder="Select ISO"
      onFocus={onFocus}
    />
  );
};

export default MetricGroupISODropdown;
